import { useTranslation } from "react-i18next";
import styled from "styled-components";
import ManufacturerInfo from "../ManufacturerInfo";
import StatusProduct from "../StatusProduct";

const InforSection = () => {
    const { t, i18n } = useTranslation();
    return (
        <InfoSection>
            <h2 className="text-2xl font-bold mb-4">
                {i18n.language === "vi" ? "Ván ép LVL" : "LVL Plywood"}
            </h2>
            <p className="mb-4">
                {i18n.language === "vi" ? (
                    <>
                        <strong>Ván ép LVL</strong> có khả năng chịu lực, chống cong vênh và đảm bảo độ bền bỉ theo thời gian
                    </>
                ) : (
                    <>
                        <strong>LVL Plywood</strong> with high load-bearing capacity, warping resistance, and long-term durability
                    </>
                )}
            </p>
            <SpecsTable>
                <tbody>
                    <tr>
                        <SpecTdLabel>{t("measurement")}</SpecTdLabel>
                        <td>
                            {i18n.language === "vi" 
                                ? "Theo yêu cầu của khách hàng" 
                                : "Custom sizes per customer requirements"}
                        </td>
                    </tr>
                    <tr>
                        <SpecTdLabel>{t("popular-thickness")}</SpecTdLabel>
                        <td>2.5 - 120mm</td>
                    </tr>
                    <tr>
                        <SpecTdLabel>{t("tolerance")}</SpecTdLabel>
                        <td>±0.5 - 1mm</td>
                    </tr>
                    <tr>
                        <SpecTdLabel>{t("species")}</SpecTdLabel>
                        <td>
                            {i18n.language === "vi" 
                                ? "Độn gỗ Thông, Keo, Bồ đề" 
                                : "Pine, Acacia, Bodhi Wood"}
                        </td>
                    </tr>
                    <tr>
                        <SpecTdLabel>{t("face")}</SpecTdLabel>
                        <td>
                            {i18n.language === "vi" 
                                ? "Không mặt" 
                                : "No Face"}
                        </td>
                    </tr>
                    <tr>
                        <SpecTdLabel>{t("glue")}</SpecTdLabel>
                        <td>E0, E1, E2</td>
                    </tr>
                    <tr>
                        <SpecTdLabel>{t("status")}</SpecTdLabel>
                        <td>
                            <StatusProduct />
                        </td>
                    </tr>
                    <tr>
                        <SpecTdLabel>{t("manufacturer")}</SpecTdLabel>
                        <td>
                            <ManufacturerInfo />
                        </td>
                    </tr>
                </tbody>
            </SpecsTable>
        </InfoSection>
    );
};

export default InforSection;

const InfoSection = styled.div`
    flex: 1;
    max-width: 600px;
    width: 100%;
`;

const SpecsTable = styled.table`
    width: 100%;
    border-collapse: collapse;
    margin-top: 16px;

    td {
        border: 1px solid #e1e1e1;
        color: #1c1c1c;
    }
`;

const SpecTdLabel = styled.td`
    font-weight: 600;
    width: 30%;
    min-width: 200px;
    @media (max-width: 768px) {
        width: 40%;
        min-width: 150px;
    }
    background-color: #f8f9fa;
`;